import React, { useState,useEffect } from 'react';
import {Box,Typography,Button, Snackbar} from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import {IconButton} from "@mui/material"
import {useSelector, useDispatch} from 'react-redux';
import {styled, useTheme} from '@mui/material/styles'
import { useNavigate,Navigate } from 'react-router-dom';
import { add_test } from '../Redux/testSlice';
import { add_tests } from '../Redux/testsSlice';
import get_tests_all from "../Redux/reducers/get_tests_all"
import { Alarm, ArrowCircleRightOutlined, ArrowDropDownOutlined, CalendarTodayOutlined, CopyAllRounded, FileOpenTwoTone, MailOutlineOutlined, NumbersTwoTone, QuizOutlined, Remove } from '@mui/icons-material';
import { FileOpen, TitleRounded } from '@mui/icons-material';
import { add_assessment } from '../Redux/templatesSlice';
import CardViewDialog from './CardViewDialog';
import { add_candidates, set_sendType } from '../Redux/settingSlice';
import axios from 'axios';
import { add_reports } from '../Redux/reportsSlice';

const DescriptionText = ({text,limit})=>{
	const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
	return <Typography  style={{fontWeight:500,fontSize:13,color:'white',marginTop:9}}> {displayText} </Typography>
}

const MaxText = ({navigate,dispatch,tst,text,limit,setVisible})=>{
	const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
	return <Button onClick={(e)=>{
	  e?.preventDefault()
	  setVisible(false)
	  dispatch(add_test(tst))
	  if(tst?.isTest){
		navigate("/testInfo")
	  }else{
		dispatch(add_assessment(tst))
		navigate("/assessmentInfo")
	  }
	}}  style={{fontWeight:500,fontSize:11,color:'white',marginTop:9,fontFamily:"dinofans",color:"gold",borderWidth:0}}> {displayText} </Button>
  }

const ContainerBox = styled(Box, {
})(({ theme}) => ({
    transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 10,
    backgroundColor: '#000000'
},
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 10
},
minHeight:250,
maxHeight:300
})
);

const CandidateAssDialog = ({visible,setVisible,data,setNewData,setCandidate})=>{

const theme = useTheme()
const user = useSelector(state => state?.auth.user);
const test = useSelector(state => state?.test.test);
const size_sm = useMediaQuery(theme.breakpoints.up('sm'));
const [loading,setLoading] = useState(false)
const dispatch = useDispatch()
const [results, setResults] = useState(data || []);
const [imageData, setImageData] = useState("https://");
const [deleting, setDeleting] = useState(false);
const [open, setOpen] = useState(false);
const [message, setMessage] = useState("");
const [selected, setSelected] = useState(0);
const navigate = useNavigate()

const onOpen = () => {
	setVisible(true);
};
const onClose = () => {
	setVisible(false);
};

async function removeCandidate(email) {
try{
    
    setDeleting(true)

    const send_data = {
        id:test.id,
        email:email
    }
    
    const removeUser = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}delete-candidate/`,send_data,{
            headers:{
                    "Content-Type":"application/json",
                    "Authorization":`Bear ${user?.accessToken}`
                }
        }).catch(err=>{
            setDeleting(false)
            setMessage("connection error")
            setOpen(true)
        }
        )
    
    if (removeUser?.data.success && removeUser.status == 200) {
        setCandidate(removeUser?.data?.accepted)
        dispatch(add_reports(removeUser?.data?.reports))
        setNewData(removeUser?.data?.reports)
        setDeleting(false)
    
    }
    }catch(err){
        console.log(err)
    }
}


return(    
	<Dialog open={visible} onClose={onClose} sx={{borderRadius:10,justifyContent:"center",textAlign:"left"}}>
		<DialogTitle sx={{background:theme.palette.background.default}}> 
        <Box width="90%" display="flex" flexDirection="row" justifyContent="space-between" alignContent="center">
            <Box display="flex" flexDirection="row" justifyContent="flex-start" alignContent="center">
				<IconButton sx={{marginTop:3}}>
					<FileOpen fontSize='small'/>
				</IconButton>					
				<Typography mr={2} mt={4} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans"}}>
					Selected candidates
				</Typography>		
			</Box> 
            <IconButton sx={{marginTop:3}} onClick={(e)=>{
                e?.preventDefault()
                dispatch(set_sendType("AI"))
                dispatch(add_candidates(data))
                navigate("/sendMail")
            }}>
                <MailOutlineOutlined/>
            </IconButton>       
        </Box>

            <Typography mr={2} mt={1} style={{fontSize:13}}>
                {data?.length ? data?.length : 0} candidate(s)
            </Typography>
		</DialogTitle>
		<DialogContent m={theme.spacing(1)} sx={{width:{xs:300,md:400},justifyContent:"center",textAlign:"center",background:theme.palette.background.default}}>
            <Snackbar 
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }} 
                message={message} 
                onClose={()=>{
                    setOpen(false)
                }} 
                open={open} 
                autoHideDuration={2000}
            />
            <ContainerBox justifyContent="center" alignItems="center" width="100%">
				{
				(data?.length == 0 ) && (
					<Box justifyContent="center" alignItems="center" width="100%" p={1}>
						<Box justifyContent="center" alignItems="center" >
							<img  width={50} height={80} src="https://res.cloudinary.com/irihocloud/image/upload/v1731198104/r14klvgmrdt5syskccyi.gif" alt="keep up" />
						</Box>
						<Typography style={{fontWeight:500,fontSize:11,color:'white',marginTop:5}}>
							Candidates could not be found
						</Typography>   
					</Box>
					)
				} 
				{
				data?.map((item,index)=>{
					return(
					<Box key={index} sx={{padding:1,borderRadius:2,margin:1,width:"99%",justifyContent:"space-between",alignContent:"center",flexDirection:"row",display:"flex",flexWrap:"wrap"}}>
						<Box sx={{display:{xs:"none",md:"flex"}}} flexDirection="row">
                            <Typography sx={{fontWeight:500,fontSize:13,color:'white',marginRight:1,fontFamily:"dinofans"}}>
                                {index+1} #
                            </Typography>
                            <img resizemode="cover" src={require("../assets/avatar.jpg")} width={50} height={50} style={{borderRadius:10}}/>
                        </Box>
                        <Box>
                            <Typography style={{fontWeight:500,fontSize:11,color:'white',marginTop:5,fontFamily:"dinofans"}}>
                                {item?.first_name} {item?.last_name}
                            </Typography> 
                            <Typography style={{fontWeight:500,fontSize:11,color:'gold',marginTop:5}}>
                                {item?.email}
                            </Typography> 
                        </Box>
                        <Box display="flex" flexDirection="row" justifyContent="flex-end" alignItems="center">
                            <Box mr={1} sx={{background:"#fff"}} justifyContent="center" alignItems="center" alignContent="center" borderRadius={5} height={35} width={45} textAlign="center">
                                <Typography sx={{fontSize:12,color:"#000",fontWeight:700}}>
                                    {item?.score} %
                                </Typography>
                            </Box>  
                            <IconButton onClick={(e)=>{
                                e?.preventDefault()
                                setSelected(index)
                                removeCandidate(item?.email)
                            }}>
                                {
                                    selected == index && deleting ? <CircularProgress sx={{color:"gold"}} size={15} /> : <Remove sx={{color:"gold"}} fontSize='small'/>
                                }
                            </IconButton>                          
                        </Box>

					</Box>
					)
				})
	            }		
			</ContainerBox>
		</DialogContent>
	</Dialog>
	)
}

export default CandidateAssDialog